<template>
  <div id="app">
    <Map :municipalities="municipalities" :projects="projects" :featureCol="featureCol" />
  </div>
</template>

<script>
/* eslint-disable */

import axios from "axios";
import moment from "moment";
import Map from "./components/Map.vue";

export default {
  name: "App",
  components: {
    Map,
  },
  data() {
    return {
      fotismos_topo: [],
      municipalities: null,
      projects: null,
      featureCol: null,
      geoJsonIni: {
        type: "FeatureCollection",
        features: [],
      },
    };
  },
  async mounted() {
    await axios.get("https://dotsoft.gr/sites/default/files/nomoi.json").then((res) => {
      this.municipalities = res.data;
    });

    await axios.get("https://dotsoft.gr/sites/default/files/uk.json").then((res) => {
      this.municipalities.features.push(res.data.features[0]);
    });

    await axios.get("https://dotsoft.gr/el/projects-json").then((res) => {
      console.log(res.data.nodes);
      res.data.nodes.forEach((prj) => {
        if (prj.node.Long) {
          this.geoJsonIni.features.push({
            type: "Feature",
            properties: prj.node,
            geometry: {
              type: "Point",
              coordinates: [
                parseFloat(prj.node.Long),
                parseFloat(prj.node.Lat),
              ],
            },
          });
        }
      });

      this.projects = this.geoJsonIni.features;
      this.featureCol = this.geoJsonIni;
    });
  },
};
</script>

<style>
#app {
  margin: auto;
  padding: auto;
}
</style>
